import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext.jsx';
import { createTeaching } from '../lib/teaching.js';
import TeachingForm from '../components/teaching/TeachingForm.jsx';

export default function TeachingNew() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, isAdmin, isActive } = useAuth();
  const [busy, setBusy] = useState(false);
  const [submitted, setSubmitted] = useState(null);

  if (!isActive) {
    return (
      <div className="mx-auto max-w-2xl px-8 pb-20 pt-32">
        <div className="cta-box">
          <h1 className="cta-title">{t('bibliography.form.notActiveTitle')}</h1>
          <p className="cta-body">{t('bibliography.form.notActiveBody')}</p>
        </div>
      </div>
    );
  }

  if (submitted) {
    const wasPublished = submitted.status === 'published';
    return (
      <div className="mx-auto max-w-2xl px-8 pb-20 pt-32">
        <div className="cta-box">
          <div className="section-label">
            {wasPublished ? t('teaching.form.publishedLabel') : t('teaching.form.submittedLabel')}
          </div>
          <h1 className="cta-title">{submitted.title}</h1>
          <p className="cta-body">
            {wasPublished
              ? t('teaching.form.publishedBody')
              : t('teaching.form.submittedBody')}
          </p>
          <button type="button" className="btn-primary" onClick={() => navigate('/teaching')}>
            {t('teaching.form.backToList')}
          </button>
        </div>
      </div>
    );
  }

  async function handleSubmit(form) {
    setBusy(true);
    try {
      const created = await createTeaching(form, { authorId: user.id, asAdmin: isAdmin });
      setSubmitted(created);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto max-w-3xl px-6 pb-20 pt-28">
      <header className="mb-8">
        <div className="section-label">{t('teaching.form.newLabel')}</div>
        <h1 className="font-serif text-3xl font-semibold text-cream">
          {t('teaching.form.newHeading')}
        </h1>
        <p className="mt-2 text-sm text-ink-secondary">
          {isAdmin
            ? t('teaching.form.newSubheadingAdmin')
            : t('teaching.form.newSubheadingCollaborator')}
        </p>
      </header>

      <TeachingForm
        showAnnounce
        submitLabel={isAdmin ? t('teaching.form.publish') : t('teaching.form.submitForReview')}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/teaching')}
        busy={busy}
      />
    </div>
  );
}
